import { render } from "./AccessList.vue?vue&type=template&id=bb229afa&scoped=true"
import script from "./AccessList.vue?vue&type=script&lang=js"
export * from "./AccessList.vue?vue&type=script&lang=js"

import "./AccessList.vue?vue&type=style&index=0&id=bb229afa&scoped=true&lang=scss"

import exportComponent from "/builds/intratone/interface/intratoneinfov4/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bb229afa"]])

export default __exports__